
/*!
 * Copyright (C) 2022-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-08-17
 *			- Refactor filter-widget.js filter-selection functionality to <hotel-filter-widget-filters> component.
 *
 *		2022-08-19
 *			- <hotel-filter-widget-filters> no longer commits directly to Vuex store (emits update-filter event instead).
 *			- <hotel-filter-widget-filters> renamed to <widget-filters>.
 *      - <widget-filters> now stops propagation of clicks on filters.
 *
 *		2023-04-03 (jhoward)
 *			- Refactor <hotel-filter-widget-filters> to use TypeScript.
 *			- Fix filter navigation on mobile in <hotel-filter-widget-filters>.
 *
 *		2024-06-10 (jhoward)
 *			- Refactor template in <hotel-filter-widget-filters> to fix interaction bug.
 *			- Add emits object in <hotel-filter-widget-filters>.
 */

import {defineComponent, PropType} from "vue";
import {StateFilter, StateFilterSelected} from "../store/hotel-rooms";

export default defineComponent({
  name: 'widget-filters',
  emits: {
    'update-filter': (payload: StateFilterSelected) => true,
    close: () => true
  },
  props: {
    isFilterOpen: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array as PropType<StateFilter[]>,
      required: true
    }
  },
  data: function () {
    let filterTypesToShow: {[key: string]: boolean} = {};
    this.filters.forEach(filter => {
      filterTypesToShow[filter.key] = false;
    });
    return {
      selectedFilters: [],
      filterTypesToShow: filterTypesToShow,
    };
  },
  computed: {
    filterContainerClasses: function () {
      return {
        hide: !this.isFilterOpen
      };
    },
    filterColumns(): [StateFilter[], StateFilter[]] {
      const columnOne = [];
      for (let i = 0, l = Math.floor(this.filters.length / 2); i < l; i++) {
        columnOne.push(this.filters[i]);
      }
      const columnTwo = [];
      for (let i = Math.floor(this.filters.length / 2), l = this.filters.length; i < l; i++) {
        columnTwo.push(this.filters[i]);
      }
      return [
        columnOne,
        columnTwo
      ];
    },
  },
  methods: {
    filterCloseButtonClick: function () {
      this.$emit('close');
    },
    titleClickHandler(filterTypeKey: string): void {
      if (filterTypeKey in this.filterTypesToShow) {
        this.filterTypesToShow[filterTypeKey] = !this.filterTypesToShow[filterTypeKey];
      } else {
        this.filterTypesToShow[filterTypeKey] = true;
      }
    },
    filterClickHandler: function (key: string, value: string, selected: boolean) {
      this.$emit('update-filter', {
        key,
        value,
        selected
      });
    }
  }
})
